module.exports = __webpack_public_path__ + "img/hr-wooden-particle-16.022fee58.png";